export const RETEST_VERDICT_BADGE = {
  STILL_VULNERABLE: 'stillVulnerable',
  REMEDIATED: 'remediated',
  PENDING_VALIDATION: 'pendingValidation',
  BLOCKED: 'blocked',
  IN_PROGRESS: 'inProgress',
} as const;

export type RetestVerdictBadge =
  (typeof RETEST_VERDICT_BADGE)[keyof typeof RETEST_VERDICT_BADGE];

const RETEST_OUTCOME = {
  CONFIRMED_VULNERABILITY: 'CONFIRMED_VULNERABILITY',
  SUSPECTED_VULNERABILITY: 'SUSPECTED_VULNERABILITY',
  NOT_OBSERVED: 'NOT_OBSERVED (NO VULNERABILITY FOUND)',
  BLOCKED: 'BLOCKED',
  FAILED: 'FAILED',
} as const;

const TERMINAL_RETEST_EXECUTION_STATUSES = new Set([
  'COMPLETED',
  'FAILED',
  'BLOCKED',
  'ABORTED',
  'STOPPED',
]);

const RETEST_VERDICT_TRANSLATION_KEY = {
  [RETEST_VERDICT_BADGE.STILL_VULNERABLE]: 'retestVerdictStillVulnerable',
  [RETEST_VERDICT_BADGE.REMEDIATED]: 'retestVerdictRemediated',
  [RETEST_VERDICT_BADGE.PENDING_VALIDATION]: 'retestVerdictPendingValidation',
  [RETEST_VERDICT_BADGE.BLOCKED]: 'retestVerdictBlocked',
  [RETEST_VERDICT_BADGE.IN_PROGRESS]: 'retestVerdictInProgress',
} as const;

export const getRetestOutcomeVerdictBadge = ({
  outcome,
  resolvedForThisThread,
}: {
  outcome?: string | null;
  resolvedForThisThread: boolean;
}): RetestVerdictBadge => {
  if (
    outcome === RETEST_OUTCOME.CONFIRMED_VULNERABILITY ||
    outcome === RETEST_OUTCOME.SUSPECTED_VULNERABILITY
  ) {
    return RETEST_VERDICT_BADGE.STILL_VULNERABLE;
  }

  if (outcome === RETEST_OUTCOME.NOT_OBSERVED) {
    return resolvedForThisThread
      ? RETEST_VERDICT_BADGE.REMEDIATED
      : RETEST_VERDICT_BADGE.PENDING_VALIDATION;
  }

  return RETEST_VERDICT_BADGE.BLOCKED;
};

export const getRetestVerdictBadge = ({
  status,
  outcome,
  resolvedForThisThread,
}: {
  status: string;
  outcome?: string | null;
  resolvedForThisThread: boolean;
}): RetestVerdictBadge =>
  TERMINAL_RETEST_EXECUTION_STATUSES.has(status)
    ? getRetestOutcomeVerdictBadge({ outcome, resolvedForThisThread })
    : RETEST_VERDICT_BADGE.IN_PROGRESS;

export const getRetestVerdictBadgeTranslationKey = (
  verdict: RetestVerdictBadge,
) => RETEST_VERDICT_TRANSLATION_KEY[verdict];
